import { Switch } from "../../../../components/ui/Form/Switch";
import {controllerChecklist} from "../../../../services/controllers/service-activation";
import {useChecklist} from "../../../../store/service-activation/useChecklist";
import {useMerchant} from "../../../../store/global/useMerchant";

export function Header(){
  const CLChecklist = controllerChecklist()
  const config = useChecklist(st=>st.data.config)

  return(
    <div className="flex flex-col gap-6 p-4 bg-white rounded border border-zinc-200/40 shadow">
      <h1 className="flex gap-4 items-center justify-start">
        <span className="h-7">
          <Switch.Root
            className="!w-12"
            name="active-conecta-pro"
            checked={config.active}
            onChange={(active) => CLChecklist.updateConfigProps({ active })}
          />
        </span>
        <span className="text-lg font-semibold text-scale-600">Ativar Checklist</span>
      </h1>
    </div>
  )
}
